import { clickInteractionType } from '@web-platform/shared-universal-types-tracking/src/MBDTypes';

import type {
  ComponentTrackingConfig,
  MBDEvent,
} from '@web-platform/shared-universal-types-tracking/src/MBDTypes';

export const buildImpressionEvent = (
  screenViewGuid: string,
  config: ComponentTrackingConfig,
): MBDEvent => ({
  view_guid: screenViewGuid,
  common: {
    component_name: config.componentName,
    numeric_properties: config.numericProperties || {},
    string_properties: {
      vertical: config.vertical,
      ...config.stringProperties,
    },
    boolean_properties: config.booleanProperties || {},
  },
});

export const buildInteractionEvent = (
  impressionGuid: string,
  config: ComponentTrackingConfig,
): MBDEvent => ({
  element_impression_guid: impressionGuid,
  interaction_type: clickInteractionType,
  common: {
    component_name: config.componentName,
    numeric_properties: config.numericProperties || {},
    string_properties: {
      vertical: config.vertical,
      ...config.stringProperties,
    },
    boolean_properties: config.booleanProperties || {},
  },
});
